import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "toggle-switch",
  templateUrl: "./toggle-switch.component.html",
  styles: [":host { display: block; }"],
})
export class ToggleSwitchComponent {
  @Input() public label: string;
  @Input() public tooltip: string;
  @Input() public placement: string = "top";
  @Input() public toggled: boolean = false;
  @Input() public containerClass: string = "";
  @Input() public iconOnClass: string = "fa-toggle-large-on toggle-primary";
  @Input() public iconOffClass: string = "fa-toggle-large-on fa-flip-horizontal toggle-disabled";
  @Input() public disabled: boolean = false;
  @Input() public labelPosition: "left" | "right" = "right";
  @Input() public size: "sm" | "md" | "lg" = "md";

  @Output() public toggledChange = new EventEmitter<boolean>();

  public onToggle(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.disabled) {
      return;
    }
    this.toggledChange.emit(!this.toggled);
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === " " || event.key === "Enter") {
      this.onToggle(event);
    }
  }
}
